/**
 * @generated SignedSource<<bcec6fafa11f4c4809087bf0f0c01b3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignUpClientWithAuthTokenInput = {
  clientMutationId?: string | null | undefined;
  code: string;
  timeZone: string;
  token: string;
};
export type useAuthTokenClientSignUpMutation$variables = {
  input: SignUpClientWithAuthTokenInput;
};
export type useAuthTokenClientSignUpMutation$data = {
  readonly signUpClientWithAuthToken: {
    readonly idToken: string;
  } | null | undefined;
};
export type useAuthTokenClientSignUpMutation = {
  response: useAuthTokenClientSignUpMutation$data;
  variables: useAuthTokenClientSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUpClientWithAuthTokenPayload",
    "kind": "LinkedField",
    "name": "signUpClientWithAuthToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "idToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthTokenClientSignUpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthTokenClientSignUpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "12345cb9aa426865818041a821d27356",
    "id": null,
    "metadata": {},
    "name": "useAuthTokenClientSignUpMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthTokenClientSignUpMutation(\n  $input: SignUpClientWithAuthTokenInput!\n) {\n  signUpClientWithAuthToken(input: $input) {\n    idToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "336a13b098b25e53a7acc8ff74620bb6";

export default node;
